'use strict';

DoohApps.factory('PaymentHelper', ['$filter', 'DoohHelper', 'DialogHandler', 'campaignBLL', '$q', 'accountBLL',
    function ($filter, DoohHelper, DialogHandler, campaignBLL, $q, accountBLL) {

        var totalSum = 0;
        var inlineConfirmation = false;
        var licenseOptions = {
            rent: { name: 'Rent', value: 0 },
            buy: { name: 'Buy', value: 1 },
            voucher: { name: 'Use voucher', value: 2 }
        };
        var accountInfo, paymentsData;

        return {
            getTotalSum: function () {
                return totalSum;
            },
            setTotalSum: function (value) {
                totalSum = value;
                return totalSum;
            },
            addTotalSum: function (value) {
                totalSum += value;
                return totalSum;
            },
            setInlineConfirmation: function (value) {
                inlineConfirmation = value;
                return inlineConfirmation;
            },
            getInlineConfirmation: function () {
                return inlineConfirmation;
            },
            calculatePaymentPeriod: calculatePaymentPeriod,
            loadVoucher: loadVoucher,
            cycleVouchers: cycleVouchers,
            switchOption: switchOption,
            licenseOptions: licenseOptionsCopy,
            checkPayment: checkPayment,
            selectedPayment: selectedPayment,
            makeTransaction: makeTransaction,
        };

        function loadAccountInfo() {
            var deferred = $q.defer();
            accountBLL.getAccountInfo(function (data) {
                accountInfo = data;
                deferred.resolve();
            });
            return deferred.promise;
        }

        function getMonthDiff(date1, date2) {
            var mTermDate = moment(date1);
            var monthsDiff = mTermDate.diff(moment(date2), 'months');
            var monthFloat = mTermDate.diff(moment(date2), 'months', true);
            if (monthFloat - monthsDiff > 0) monthsDiff += 1;
            if (monthsDiff <= 0) monthsDiff = 1;
            return monthsDiff;
        }

        function getLicenseOptionByValue(value) {
            switch (value) {
                case 0:
                    return angular.copy(licenseOptions.rent);
                case 1:
                    return angular.copy(licenseOptions.buy);
                case 2:
                    return angular.copy(licenseOptions.voucher);
            }
        }

        function licenseOptionsCopy() {
            return angular.copy(licenseOptions);
        }

        function calculatePaymentPeriod(dev, calendarStart, calendarEnd, startDate, tzName, devHasPartnerLicense) {//StartDate - $scope.RepeatData.StartDate
            var sls, newDiff;
            if (dev.LicensesPeriods != undefined && dev.LicensesPeriods.length != 0 && !devHasPartnerLicense) {
                if (dev.LicensesPeriods.length == 1) {
                    if (moment(dev.LicensesPeriods[0][0].StartDate) > moment(calendarStart)) {
                        dev.setLicenseStart = DoohHelper.stringToDate(moment(calendarStart)
                            .format(DoohHelper.dcFormat), true);
                        dev.monthsDiff = getMonthDiff(calendarEnd, calendarStart);
                        //recheck month diff
                        newDiff = recheckMonthDiff(dev.LicensesPeriods, calendarStart, dev.monthsDiff, false);
                        if (newDiff[0] != undefined)
                            dev.monthsDiff = newDiff[0];
                        dev.setLicenseEnd = DoohHelper.stringToDate(moment(startDate)
                            .add(dev.monthsDiff, 'months')
                            .format(DoohHelper.dcFormat), true);
                    }
                    else {
                        dev.monthsDiff = getMonthDiff(calendarEnd, dev.LicensesPeriods[0][dev.LicensesPeriods[0].length - 1].ExpiredDate);
                        sls = moment(dev.LicensesPeriods[0][dev.LicensesPeriods[0].length - 1].ExpiredDate)
                            .format(DoohHelper.dcFormat);// + " 00:00";
                        dev.setLicenseStart = DoohHelper.stringToDate(sls, true);
                        var sle = moment(dev.LicensesPeriods[0][dev.LicensesPeriods[0].length - 1].ExpiredDate)
                            .add(dev.monthsDiff, 'months')
                            .format(DoohHelper.dcFormat);
                        dev.setLicenseEnd = DoohHelper.stringToDate(sle, true);
                    }
                }
                else {
                    if (moment(dev.LicensesPeriods[0][0].StartDate) > moment(calendarStart)) {
                        sls = moment(calendarStart)
                            .format(DoohHelper.dcFormat);// + " 00:00";
                        dev.setLicenseStart = DoohHelper.stringToDate(sls, true);
                        dev.monthsDiff = getMonthDiff(calendarEnd, calendarStart);
                        //recheck month diff
                        newDiff = recheckMonthDiff(dev.LicensesPeriods, calendarStart, dev.monthsDiff, true);
                        if (newDiff[0] != undefined) {
                            dev.monthsDiff = newDiff[0];
                            dev.NextStart = newDiff[1];
                        }
                        var sle = moment(startDate)
                            .add(dev.monthsDiff, 'months')
                            .format(DoohHelper.dcFormat);
                        dev.setLicenseEnd = DoohHelper.stringToDate(sle, true);
                    }
                    else {
                        dev.monthsDiff = getMonthDiff(calendarEnd, dev.LicensesPeriods[0][dev.LicensesPeriods[0].length - 1].ExpiredDate);
                        newDiff = recheckMonthDiff(
                            dev.LicensesPeriods,
                            dev.LicensesPeriods[0][dev.LicensesPeriods[0].length - 1].ExpiredDate,
                            dev.monthsDiff,
                            true);
                        if (newDiff[0] != undefined) {
                            dev.monthsDiff = newDiff[0];
                            dev.NextStart = newDiff[1];
                        }

                        sls = moment(dev.LicensesPeriods[0][dev.LicensesPeriods[0].length - 1].ExpiredDate)
                            .format(DoohHelper.dcFormat);// + " 00:00";
                        dev.setLicenseStart = DoohHelper.stringToDate(sls, true);
                        var sle = moment(dev.LicensesPeriods[0][dev.LicensesPeriods[0].length - 1].ExpiredDate)
                            .add(dev.monthsDiff, 'months').format(DoohHelper.dcFormat);
                        dev.setLicenseEnd = DoohHelper.stringToDate(sle, true);
                    }
                }
            }
            else {
                dev.monthsDiff = getMonthDiff(calendarEnd, calendarStart);
                var sle = moment(startDate)
                    .add(dev.monthsDiff, 'months')
                    .tz(tzName)
                    .format(DoohHelper.dcFormat);
                dev.setLicenseEnd = DoohHelper.stringToDate(sle, true);
                sls = moment(startDate)
                    .tz(tzName)
                    .format(DoohHelper.dcFormat);
                dev.setLicenseStart = DoohHelper.stringToDate(sls, true);
            }
        }

        function recheckMonthDiff(licensePeriods, dStart, monthsDiff, first) {
            var newDiff;
            var start;
            //extend only until next license period, if any exists
            for (var counter = 1; counter < monthsDiff; counter++) {
                var testdate = moment(dStart)
                    .add(counter, 'months');
                for (var lp = 0; lp < licensePeriods.length; lp++) {
                    var momdStart = moment(dStart);
                    var licenseEnd = moment(licensePeriods[lp][licensePeriods[lp].length - 1].ExpiredDate);
                    if (momdStart >= licenseEnd) continue;
                    else {
                        var licenseStart;
                        if (first) licenseStart = moment(licensePeriods[lp][0].StartDate);
                        else licenseStart = moment(licensePeriods[lp][licensePeriods[lp].length - 1].StartDate);
                        if (testdate >= licenseStart) {
                            newDiff = counter;
                            start = DoohHelper.momentToDate(licenseStart);
                            break;
                        }
                        else break;
                    }
                }
                if (newDiff != undefined) break;
            }
            return [newDiff, start];
        }

        function cycleVouchers(vouchers, dev, errorMsgs) {
            inlineConfirmation = false;
            clearPaymentErrorMsg(errorMsgs);
            if (vouchers.length != 1) {
                var index = -1;
                angular.forEach(vouchers, function (voucher, key) {
                    if (voucher.VoucherID == dev.showVoucher.VoucherID) {
                        index = key;
                    }
                });
                if (index != -1) {
                    if (index + 1 > vouchers.length - 1) dev.showVoucher = vouchers[0];
                    else dev.showVoucher = vouchers[index + 1];
                }
            }
        }

        function loadVoucher(expireDate, issuedDate, ignoreDateParams, repeatPlaceHolders, applicationID, vendorID, noLicenseDevices, isAllDay, licenseAqure) {
            if (!ignoreDateParams && expireDate == undefined && issuedDate == undefined) {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            }
            else {
                if (isAllDay) expireDate = moment(expireDate).add(1, 'days').format(DoohHelper.dtcFormat);
                var promises = [];

                promises = noLicenseDevices.map(function (dev) {
                    var deferred = $q.defer();
                    campaignBLL.VoucherList(function (data) {
                        dev.VoucherList = [];
                        var VoucherList = data;
                        angular.forEach(VoucherList, function (voucher) {
                            var canBeUsed = false;

                            if (licenseAqure && voucher.LicenseType != 0) canBeUsed = false;
                            else if (repeatPlaceHolders != undefined && repeatPlaceHolders.length != 0) {
                                if (dev.LicensesPeriods != undefined && dev.LicensesPeriods.length > 0) {
                                    var vsdate = DoohHelper.momentToDate(moment(voucher.IssueDate));
                                    angular.forEach(dev.LicensesPeriods, function (licenseList) {
                                        if (!canBeUsed)
                                            angular.forEach(licenseList, function (license) {
                                                if (!canBeUsed) {
                                                    var ledate = DoohHelper.momentToDate(moment(license.ExpiredDate));
                                                    if (ledate - vsdate >= 0) {
                                                        canBeUsed = true;
                                                    }
                                                }
                                            });
                                    });
                                }
                                else {
                                    if (moment(repeatPlaceHolders[repeatPlaceHolders.length - 1].TimeEnd) <= moment(voucher.ExpiryDate)
                                        && ((DoohHelper.isValidAndMatchID(dev.GroupID) && voucher.RemainingScreens == dev.noLicenseDevices.length)
                                            || DoohHelper.isValidAndMatchID(dev.MediaID))) {
                                        canBeUsed = true;
                                    }
                                }
                            }
                            else {
                                if ((moment(issuedDate) >= moment(voucher.IssueDate)
                                    && moment(expireDate) <= moment(voucher.ExpiryDate)
                                    && moment(issuedDate) <= moment(voucher.ExpiryDate))
                                    && ((DoohHelper.isValidAndMatchID(dev.GroupID) && voucher.RemainingScreens >= dev.noLicenseDevices.length)
                                        || DoohHelper.isValidAndMatchID(dev.MediaID)))
                                    canBeUsed = true;
                            }
                            if (canBeUsed) {
                                if (voucher.VendorId != null) {
                                    if (voucher.VendorId == (vendorID == undefined ? dev.VendorID : vendorID)) {
                                        dev.VoucherList.push(voucher);
                                    }
                                } else dev.VoucherList.push(voucher);
                            }
                        });
                        if (dev.VoucherList.length != 0) dev.showVoucher = dev.VoucherList[0];

                        deferred.resolve();
                    },
                        applicationID == undefined ? dev.ApplicationID : applicationID,
                        dev.MediaID,
                        dev.GroupID,
                        expireDate == undefined ? dev.TimePeriod.m_Item2 : expireDate,
                        issuedDate == undefined ? dev.TimePeriod.m_Item1 : issuedDate);

                    return deferred.promise;

                });

                return $q.all(promises);
            }
        }

        function switchOption(dev, option, rentingPrice, price, errorMsgs) {
            inlineConfirmation = false;
            clearPaymentErrorMsg(errorMsgs);

            totalSum = Number(totalSum);
            switch (dev.licenseOption.value) {
                case 0:
                    totalSum -= ((rentingPrice * dev.monthsDiff * (DoohHelper.isValidAndMatchID(dev.GroupID) ? dev.noLicenseDevices.length : 1)));
                    break;
                case 1:
                    totalSum -= (price * (DoohHelper.isValidAndMatchID(dev.GroupID) ? dev.noLicenseDevices.length : 1));
                    break;
            }
            totalSum = Number(totalSum);

            switch (option != undefined ? option : dev.licenseOption.value) {
                case 0:
                    if (option != undefined) {
                        totalSum += ((rentingPrice * dev.monthsDiff * (DoohHelper.isValidAndMatchID(dev.GroupID) ? dev.noLicenseDevices.length : 1)));
                    } else {
                        dev.licenseOption = licenseOptionsCopy().buy;
                        totalSum += (price * (DoohHelper.isValidAndMatchID(dev.GroupID) ? dev.noLicenseDevices.length : 1));
                    }
                    break;
                case 1:
                    if (option != undefined) {
                        totalSum += (price * (DoohHelper.isValidAndMatchID(dev.GroupID) ? dev.noLicenseDevices.length : 1));
                    } else {
                        dev.licenseOption = licenseOptionsCopy().voucher;
                    }
                    break;
                case 2:
                    if (option == undefined) {
                        dev.licenseOption = licenseOptionsCopy().rent;
                        totalSum += ((rentingPrice * dev.monthsDiff * (DoohHelper.isValidAndMatchID(dev.GroupID) ? dev.noLicenseDevices.length : 1)));
                    }
                    break;
            }
            if (option != undefined) dev.licenseOption = getLicenseOptionByValue(option);
            totalSum = (totalSum).toFixed(2);
        }

        function checkPayment(noLicenseDevices, errorMsgs, isPriceAvailable) {
            var deferred = $q.defer();
            //check voucher use
            var usingVouchers = [];
            for (var em = errorMsgs.length - 1; em >= 0; em--) {
                if (errorMsgs[em].code == 'checkPayment') {
                    errorMsgs.splice(em, 1);
                }
            }

            angular.forEach(noLicenseDevices, function (dev) {
                if (dev.licenseOption.value == 2) {
                    if (usingVouchers.length != 0 && dev.showVoucher != undefined) {
                        angular.forEach(usingVouchers, function (voucher) {
                            if (voucher.VoucherID == dev.showVoucher.VoucherID) {
                                if (voucher.usageCount != undefined) {
                                    voucher.usageCount += dev.noLicenseDevices && dev.noLicenseDevices.length > 0 ?
                                        dev.noLicenseDevices.length : 1;
                                }
                            }
                            else if (DoohHelper.findWithAttr(usingVouchers, 'VoucherID', dev.showVoucher.VoucherID) == -1) {
                                if (!voucher.usageCount) voucher.usageCount = 0;
                                voucher.usageCount += dev.noLicenseDevices && dev.noLicenseDevices.length > 0 ?
                                    dev.noLicenseDevices.length : 1;
                                usingVouchers.push(dev.showVoucher);
                            }
                        });
                    }
                    else {
                        if (dev.showVoucher != undefined && dev.VoucherList.length > 0) {
                            dev.showVoucher.usageCount = dev.noLicenseDevices && dev.noLicenseDevices.length > 0 ?
                                dev.noLicenseDevices.length : 1;
                            usingVouchers.push(dev.showVoucher);
                        }
                        else {
                            var message;
                            if (isPriceAvailable) message = 'No vouchers available for ' + (dev.ScreenTitle ? dev.ScreenTitle : dev.GroupName) + '.';
                            else message = 'No payment methods available for ' + (dev.ScreenTitle ? dev.ScreenTitle : dev.GroupName) + '!';
                            errorMsgs.push({ code: 'checkPayment', message: message });
                        }
                    }
                }
            });

            angular.forEach(usingVouchers, function (voucher) {
                if (voucher.RemainingScreens != null) {
                    if (voucher.usageCount != undefined && voucher.usageCount > voucher.RemainingScreens) {
                        errorMsgs.push({ code: 'checkPayment', message: 'Voucher "' + voucher.Name + '" used too many times!' });
                        voucher.usageCount = 0;
                    }
                }
            });

            loadAccountInfo().then(function () {
                if (isPriceAvailable) {
                    var totalSum = Number(totalSum);
                    if (totalSum > accountInfo.Balance) errorMsgs.push({ code: 'checkPayment', message: 'Insufficient funds.' });
                }

                deferred.resolve();
            });

            return deferred.promise;
        }

        function selectedPayment(errorMsgs, scheduleError, scheduleInPastMsg, noLicenseDevices, chosenCampaign) {
            var paymentErrors = false;
            
            if (errorMsgs.filter(message => message.code == 'checkPayment').length > 0)
                paymentErrors = true;
            
            if ((!paymentErrors && !scheduleError) || (!paymentErrors && scheduleError && (scheduleError == scheduleInPastMsg.All || scheduleError == scheduleInPastMsg.Some))) {
                errorMsgs = errorMsgs.filter(message => !(message.code == 'SaveSchedule' && message.subcode == 'L'));
                
                applicationTransaction(noLicenseDevices, chosenCampaign);
                inlineConfirmation = true;
            }
            else if (scheduleError) {
                DialogHandler.AddError('Schedule error is not resolved!', true);
            }
        }

        function applicationTransaction(noLicenseDevices, chosenCampaign) {
            paymentsData = [];
            var tzName = moment.tz.guess();
            angular.forEach(noLicenseDevices, function (dev) {
                if (DoohHelper.isValidAndMatchID(dev.MediaID)) paymentsData.push(getTransactionDetails(dev, tzName,
                    chosenCampaign == undefined ? dev.Price : chosenCampaign.Price,
                    chosenCampaign == undefined ? dev.RentingPrice : chosenCampaign.RentingPrice,
                    chosenCampaign == undefined ? dev.ApplicationID : chosenCampaign.ApplicationID,
                    chosenCampaign == undefined ? 0 : chosenCampaign.CampaignID
                ));
                else {
                    angular.forEach(dev.noLicenseDevices, function (nlDev) {
                        nlDev.licenseOption = dev.licenseOption;
                        nlDev.showVoucher = dev.showVoucher;
                        paymentsData.push(getTransactionDetails(nlDev, tzName,
                            chosenCampaign == undefined ? nlDev.Price : chosenCampaign.Price,
                            chosenCampaign == undefined ? nlDev.RentingPrice : chosenCampaign.RentingPrice,
                            chosenCampaign == undefined ? nlDev.ApplicationID : chosenCampaign.ApplicationID,
                            chosenCampaign == undefined ? 0 : chosenCampaign.CampaignID
                        ));
                    });
                }
            });
        }

        function getTransactionDetails(dev, tzName, price, rentingPrice, applicationID, campaignID) {
            var paymentData = {};
            switch (dev.licenseOption.value) {
                case 0:
                    paymentData.IsVoucherPayment = false;
                    paymentData.VoucherId = null;
                    paymentData.Duration = dev.monthsDiff;
                    if (rentingPrice == null) rentingPrice = 0;
                    paymentData.VoucherAmount = rentingPrice * dev.monthsDiff;
                    paymentData.TransactionType = 'Rent';
                    paymentData.ExpiredDate = moment(dev.setLicenseEnd).tz(tzName).format(DoohHelper.dcFormat);
                    break;
                case 1:
                    paymentData.IsVoucherPayment = false;
                    paymentData.VoucherId = null;
                    paymentData.Duration = 0;
                    if (price == null) price = 0;
                    paymentData.VoucherAmount = price;
                    paymentData.TransactionType = 'Buy';
                    break;
                case 2:
                    paymentData.IsVoucherPayment = true;
                    paymentData.VoucherId = dev.showVoucher.VoucherID;
                    paymentData.Duration = 0;
                    paymentData.VoucherAmount = null;
                    paymentData.TransactionType = null;
                    break;
                default:
                    break;
            }
            paymentData.Credit = 0;
            paymentData.CampaignId = campaignID == undefined ? 0 : campaignID;
            paymentData.ApplicationId = applicationID;

            paymentData.MediaID = dev.MediaID;
            paymentData.StartDate = moment(dev.setLicenseStart)
                .tz(tzName)
                .format(DoohHelper.dcFormat);

            paymentData.AccountId = accountInfo.AccountID;
            return paymentData;
        }

        function makeTransaction() {

            var deferred = $q.defer();
            campaignBLL.MakeTransaction(function (data) {
                if (data.error_description != undefined) {
                    DialogHandler.AddError(data.error_description);
                }
                else {
                    accountInfo.Balance = (accountInfo.Balance - Number(totalSum));
                }
                inlineConfirmation = false;
                deferred.resolve();

            }, { 'payments': paymentsData });
            return deferred.promise;
        }

        function clearPaymentErrorMsg(errorMsgs) {
            for (var em = errorMsgs.length - 1; em >= 0; em--) {
                if (errorMsgs.length > 0 && (errorMsgs[em].code == 'checkPayment'
                    || (errorMsgs[em].code == 'SaveSchedule'
                        && (errorMsgs[em].subcode != undefined
                            && errorMsgs[em].subcode == 'L')))) {
                    errorMsgs.splice(em, 1);
                }
            }
        }
    }]);